export default __webpack_public_path__ + "static/media/cityEn.cb397ca4.png";